/**
 * Contenido del Aviso de Privacidad NPMX (NPM-L0003-E2 — 2023-08-15).
 * Vive en el frontend para conservar formato y reducir payload del endpoint.
 * Si cambia el contenido, publicar nueva versión en kernel.condiciones_uso y
 * actualizar este componente con el HTML correspondiente.
 */
export function CondicionesUsoContenido() {
  return (
    <article className="prose prose-sm max-w-none text-fg">
      <header className="mb-4 border-b pb-3">
        <h2 className="m-0 text-xl font-bold text-primary-strong">Aviso de Privacidad</h2>
        <p className="mt-1 text-sm text-fg-muted">
          Consulte la información relacionada con el tratamiento, resguardo y protección de
          los datos personales recabados por Normalización Profesional de México, S.C.
        </p>
      </header>

      <Bloque titulo="1. Identidad y domicilio del responsable">
        <p>
          Normalización Profesional de México, S.C. (NPMX), con domicilio en Alborada 124
          Int. 903, Col. Parque del Pedregal, Tlalpan, Ciudad de México, C.P. 14010, es
          responsable del uso y manejo de los datos personales de titulares y su
          protección.
        </p>
        <p>
          Para cualquier duda, comentario, notificación y/o queja respecto del manejo de
          sus datos personales, se puede poner en contacto con el responsable de Calidad
          Interna, en la dirección mencionada arriba o al teléfono (55) 1520-5386, o al
          correo electrónico{" "}
          <a className="text-primary-strong underline" href="mailto:contacto@npmx.org">
            contacto@npmx.org
          </a>{" "}
          o visitar nuestra página web en{" "}
          <a
            className="text-primary-strong underline"
            href="https://www.npmx.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.npmx.org
          </a>
          .
        </p>
      </Bloque>

      <Bloque titulo="2. Formas de obtención o recabado de los datos personales">
        <p>
          Esta información es obtenida de su registro legal ante NPMX, las solicitudes de
          servicio ingresadas por correo electrónico, página de internet o físicas. Esta
          información es utilizada para dar cumplimiento a lo establecido en NPM0029*
          Formato de registro legal.
        </p>
        <p>
          NPMX puede grabar audios, videos y/o tomar fotografías de los eventos y cursos
          que realiza. Si usted participa en estos eventos y actividades, acepta que podrá
          ser grabado y/o fotografiado, consintiendo que NPMX los podrá utilizar,
          distribuir o transmitir en redes sociales y propaganda de NPMX exclusivamente.
        </p>
      </Bloque>

      <Bloque titulo="3. Tratamiento de datos personales">
        <p>
          Los datos personales que, en su caso, se recaban incluyen identificación, datos
          de contacto, financieros y lo establecido dentro del NPM0029* Formato de registro
          legal.
        </p>
      </Bloque>

      <Bloque titulo="4. Consentimiento">
        <p>
          En caso de que usted decida revocar el consentimiento o limitar el uso de sus
          datos personales, deberá solicitarlo proporcionando la información mencionada en
          la sección 6, ya sea a través de los medios electrónicos indicados o en forma
          personal en el domicilio del responsable de Calidad Interna.
        </p>
      </Bloque>

      <Bloque titulo="5. Transferencias nacionales o internacionales">
        <p>
          Los datos personales serán transferidos en caso de ser requeridos a dependencias
          gubernamentales, con el objetivo de cumplir con la Autoridad.
        </p>
      </Bloque>

      <Bloque titulo="6. Ventanilla ARCO">
        <p>
          Usted tiene derecho al acceso, rectificación, cancelación u oposición (derechos
          ARCO) sobre el tratamiento de sus datos personales.
        </p>
      </Bloque>

      <Bloque titulo="7. Acerca de este aviso de privacidad">
        <p>
          Si desea conocer más sobre este Aviso de Privacidad, puede contactarse con el
          responsable de Calidad Interna en el domicilio mencionado anteriormente.
        </p>
      </Bloque>

      <Bloque titulo="8. Uso de circuito cerrado de video vigilancia">
        <p>
          Se utilizan circuitos cerrados de video vigilancia en nuestras oficinas con la
          finalidad de proporcionar seguridad física en nuestras instalaciones.
        </p>
      </Bloque>

      <Bloque titulo="9. Actualización de este aviso de privacidad">
        <p>
          Este aviso de privacidad puede tener modificaciones, las cuales podrán ser
          consultadas en nuestra página web:{" "}
          <a
            className="text-primary-strong underline"
            href="https://www.npmx.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.npmx.org
          </a>{" "}
          y en nuestras oficinas.
        </p>
      </Bloque>

      <footer className="mt-4 border-t pt-3 text-center text-xs text-fg-muted">
        <p>
          <span className="font-semibold">Fecha de actualización:</span> 2023-08-15
        </p>
        <p>
          <span className="font-semibold">Código:</span> NPM-L0003-E2
        </p>
      </footer>
    </article>
  );
}

function Bloque({ titulo, children }: { titulo: string; children: React.ReactNode }) {
  return (
    <section className="mb-4 border-b border-edge/60 pb-3 last:border-b-0">
      <h3 className="m-0 mb-2 text-base font-semibold text-primary-strong">{titulo}</h3>
      <div className="space-y-2 text-sm leading-relaxed text-fg-muted">{children}</div>
    </section>
  );
}
